import { render, staticRenderFns } from "./CustomerStats.vue?vue&type=template&id=0640d87e&scoped=true&"
import script from "./CustomerStats.vue?vue&type=script&lang=ts&"
export * from "./CustomerStats.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerStats.vue?vue&type=style&index=0&id=0640d87e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0640d87e",
  null
  
)

component.options.__file = "CustomerStats.vue"
export default component.exports